var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"text-h3 text-uppercase text-center"},[_vm._v("Información")]),_c('UserInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }